exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mensaje {\r\n  border: 1px solid #f5c6cb;\r\n  background-color: #f8d7da;\r\n  color: #721c24;\r\n  border-radius: 4px;\r\n  margin: 10px 0;\r\n  width: 100%;\r\n}\r\n\r\n.mensaje-header {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  font-weight: bold;\r\n  padding: 5px 10px;\r\n  border-bottom: 1px solid #f5c6cb;\r\n  position: relative;\r\n}\r\n\r\n.mensaje-header .titulo {\r\n  font-size: 14px;\r\n  text-align: center;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1;\r\n          flex: 1;\r\n}\r\n\r\n.mensaje-body {\r\n  padding: 10px;\r\n  font-size: 13px;\r\n  text-align: justify;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/public/login.component.css
// module id = ../../../../../src/app/public/login.component.css
// module chunks = main